// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk-" + chunkId + "-" + {"326":"ca711b5a036b3475f1c5","970":"c5bb5689eeabfc039bde"}[chunkId] + ".js";
};